<!-- @format -->
<ng-container id="pdp-pro-tips">
	@if (isBrowser) {
		@if(articleData().length > 0) {
			<h3 class="hmf-display-flex hmf-justify-content-center">
				<img
					class="hmf-m-xs"
					[src]="headerSvg"
					[alt]="altSvgText"
					draggable="false"
					loading="lazy" />
			</h3>
			<hmf-carousel
				[showHeader]="false"
				[showTitle]="false"
				[showSubtitle]="false"
				[showActionButton]="false">
				@for (article of articleData(); track article.id) {
					<article
						class="pro-tips-card"
						[class.hmf-mr-s]="!$last">
						<a
							[href]="article.url"
							class="no-underline"
							target="_blank">
							<div class="pro-tips-card__image">
								<img
									class="hmf-w-100 hmf-h-100"
									[src]="article.image"
									[alt]="article.title"
									loading="lazy" />
							</div>
							<div
								class="pro-tips-card__content hmf-display-flex hmf-flex-column hmf-p-s hms-h-100">
								<h2 class="hmf-header-bold-s hmf-mt-0 hmf-mb-xxs hms-position-relative">
									{{ article.title }}
								</h2>
								<p class="summary hmf-body-m hmf-mt-0">
									{{ article.description }}
								</p>
							</div>
						</a>
					</article>
				}
			</hmf-carousel>
		}
	}
</ng-container>
